/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerStockEntry, ApiContainerStockGroup } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerStockController.
 */
export class ContainerStockRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /containers/stock
     */
    public getStockAtSite(siteId: string, customerId: string, validAt: string | undefined): Promise<Result<ApiContainerStockEntry[]>> {
        const query = new URLSearchParams();
        query.set('site_id', `${siteId}`);
        query.set('customer_id', `${customerId}`);
        if (validAt !== undefined) {
            query.set('valid_at', `${validAt}`);
        }

        return this.http.get<Result<ApiContainerStockEntry[]>>('/containers/stock', query);
    }

    /**
     * Calls GET /containers/stock:query
     */
    public getStockGet(pageNo: number, pageSize: number, validAt: string | undefined): Promise<Result<ListInfo<ApiContainerStockEntry>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (validAt !== undefined) {
            query.set('valid_at', `${validAt}`);
        }

        return this.http.get<Result<ListInfo<ApiContainerStockEntry>>>('/containers/stock:query', query);
    }

    /**
     * Calls POST /containers/stock:query
     */
    public getStockPost(listRequest: ListRequest, validAt: string | undefined): Promise<Result<ListInfo<ApiContainerStockEntry>>> {
        const query = new URLSearchParams();
        if (validAt !== undefined) {
            query.set('valid_at', `${validAt}`);
        }

        return this.http.post<Result<ListInfo<ApiContainerStockEntry>>, ListRequest>('/containers/stock:query', listRequest, query);
    }

    /**
     * Calls POST /containers/stock/groups:query
     */
    public getStockGroups(listRequest: ListRequest, validAt: string | undefined): Promise<Result<ListInfo<ApiContainerStockGroup>>> {
        const query = new URLSearchParams();
        if (validAt !== undefined) {
            query.set('valid_at', `${validAt}`);
        }

        return this.http.post<Result<ListInfo<ApiContainerStockGroup>>, ListRequest>('/containers/stock/groups:query', listRequest, query);
    }

    /**
     * Calls PUT /containers/stock/{standingTimeId}
     */
    public correctStock(standingTimeId: string, entry: ApiContainerStockEntry): Promise<Result<ApiContainerStockEntry>> {
        return this.http.put<Result<ApiContainerStockEntry>, ApiContainerStockEntry>(`/containers/stock/${standingTimeId}`, entry);
    }

    /**
     * Calls POST /containers/stock
     */
    public addToStock(entry: ApiContainerStockEntry): Promise<Result<ApiContainerStockEntry>> {
        return this.http.post<Result<ApiContainerStockEntry>, ApiContainerStockEntry>('/containers/stock', entry);
    }
}
